import rangy from '@yola/rangy';
import '@yola/rangy/lib/rangy-classapplier';
import bowser from 'yola-bowser';
import hooks from '../../hooks';

const wrappers = {};

if (bowser.firefox) {
  hooks.operations.subscribe(hooks.availableHooks.ON_LIVE_DOCUMENT_CONNECTED, () => {
    if (!rangy.initialized) rangy.init();
  });
}

const registerWrapper = (id, className, tagName, attributes) => {
  if (wrappers[id]) throw new Error('wrapper with specified id is already exist');

  wrappers[id] = rangy.createClassApplier(className, {
    elementTagName: tagName,
    elementAttributes: {
      ...attributes,
    },
  });
};

const getWrapperById = (id) => wrappers[id];

const removeWrapper = (id) => {
  delete wrappers[id];
};

export default {
  registerWrapper,
  getWrapperById,
  removeWrapper,
};
